// extracted by mini-css-extract-plugin
export default {"email":"Completed_email__WLIs9"};